// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "api";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const classesApi = createApi({
  reducerPath: "classesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
    prepareHeaders: async (headers) => {
      const token = await getToken();

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      // 🚫 Disable cache
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      headers.set("Pragma", "no-cache");
      headers.set("Expires", "0");

      return headers;
    },
  }),

  endpoints: (builder) => ({
    getRooms: builder.query<any, void>({
      query: (profId) => `/classes?teacher=${profId}`,
    }),
    getHistorique: builder.query<any, string>({
      query: (profId) => `/advertisements/fetch/Reservations?profId=${profId}`,
    }),
    getTeacherReservations: builder.query<any, string>({
      query: (profId) => `/advertisements/fetch/Reservations?profId=${profId}&typeCreneaux=individuel`,
    }),
    getTeacherReservationsByClass: builder.query<any, { profId: string; classeId: string }>({
      query: ({ profId, classeId }) => `/advertisements/fetch/Reservations?profId=${profId}&classeId=${classeId}`,
    }),
    getHistoriqueStudent: builder.query<any, string>({
      query: (studId) => `/advertisements/fetch/Reservations?studId=${studId}`,
    }),
    getStudentReservations: builder.query<any, string>({
      query: (studId) => `/advertisements/fetch/Reservations?studId=${studId}&typeCreneaux=individuel`,
    }),
    getHistoriqueReservationsStudent: builder.query<any, string>({
      query: (studId) =>
        `/advertisements/fetch/Reservations/historique?studId=${studId}`,
    }),
    getHistoriqueReservationsTeacher: builder.query<any, string>({
      query: (profId) =>
        `/advertisements/fetch/Reservations/historique?profId=${profId}`,
    }),
    getOrganismRooms: builder.query<any, void>({
      query: (organismId) => `/classes?teacher=${organismId}&isCollective=true`,
    }),
    getHistoriqueOrganismByClass: builder.query<any, { userId: string; classId: string }>({
      query: ({ userId, classId }) =>
        `/advertisements/fetch/collective/reserves?userId=${userId}&classId=${classId}`,
    }),
    getHistoriqueCoursesOrganismByClass: builder.query<any, { userId: string; classId: string }>({
      query: ({ userId, classId }) =>
        `/advertisements/fetch/collective/reserves/history?userId=${userId}&classId=${classId}`,
    }),
    getHistoriqueOrganism: builder.query<any, { organismeId: string }>({
      query: ({ organismeId }) =>
        `/advertisements/fetch/reserves/organism/${organismeId}`,
    }),
    getHistoriqueCoursesOrganism: builder.query<any, { organismId: string }>({
      query: ({ organismId }) =>
        `/advertisements/fetch/reserves/history/organism/${organismId}`,
    }),
    getTeacherRooms: builder.query<any, void>({
      query: (profId) => `/classes?isCollective=true&teacher=${profId}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetHistoriqueQuery,
  useGetHistoriqueStudentQuery,
  useGetTeacherReservationsQuery,
  useGetTeacherReservationsByClassQuery,
  useGetHistoriqueReservationsStudentQuery,
  useGetStudentReservationsQuery,
  useGetHistoriqueReservationsTeacherQuery,
  useGetRoomsQuery,
  useGetOrganismRoomsQuery,
  useGetHistoriqueOrganismByClassQuery,
  useGetHistoriqueCoursesOrganismByClassQuery,
  useGetHistoriqueOrganismQuery,
  useGetHistoriqueCoursesOrganismQuery,
  useGetTeacherRoomsQuery
} = classesApi;
